import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { EVENT_FORCE_ROUTE_CHANGE } from "../../Events";
import { withHubx, withHubxType } from "../../HubX";

class RouteListener extends React.Component<withHubxType & RouteComponentProps> {
  constructor(props: withHubxType & RouteComponentProps) {
    super(props);

    this.pushHistory = this.pushHistory.bind(this);

    this.props.attach(EVENT_FORCE_ROUTE_CHANGE, this.pushHistory);
  }

  pushHistory(newRoute: string) {
    this.props.history.push(newRoute);
  }

  render() {
    return null;
  }
}

export default withHubx(withRouter(RouteListener));
